<style lang="scss" scoped>
.image_delete {
  margin-left: 5px;
}
.img__name {
  display: flex;
}
@media screen and (max-width: 740px) {
  .mobile-header {
    margin-bottom: 0;
  }
  .image_delete {
    margin-left: 5px;
  }
  .save-info {
    margin-right: 0 !important;
    padding: 7px !important;
    display: block;
    width: 100%;
  }
  .form-data {
    margin-top: 20px;
  }
  .input-mobile {
    margin-top: 20px;
  }
  .cancel-btn {
    padding: 7px 30px !important;
    font-weight: 600;
    background: #f6f6f6;
    border: 2px solid #0d2e48;
    color: #0d2e48;
    margin-top: 5px;
    width: 100%;
  }
  .padding-mobile {
    padding: 0 !important;
  }

  #fileImage {
    overflow: hidden;
  }
}
.save-info {
  background: #b4daf3;
  font-weight: 600;
  padding: 7px 70px;
  color: #0d2e48;
  margin-right: 20px;
  border: 2px solid #b4daf3;
}

label {
  font-weight: 600;
}

.input-group {
  margin-bottom: 0px !important;
}

.row {
  margin-bottom: 20px;
}

.cancel-btn {
  padding: 7px 45px;
  font-weight: 600;
  background: #f6f6f6;
  border: 2px solid #0d2e48;
  color: #0d2e48;
}

span.require {
  color: #ff1a1a;
}

span.required {
  color: #ff1a1a;
  margin-top: -15px;
}

.form-data {
  text-align: center;
}

p.note {
  font-weight: 700;
  color: #ff1a1a;
}
</style>

<template>
  <div>
    <ValidationObserver ref="formAdditionalTimeSheet" v-slot="{ handleSubmit }">
      <CForm
        class="create_form"
        @submit.prevent="handleSubmit(registerOverTimeRequest)"
      >
        <CRow>
          <CCol md="6" class="form-field">
            <label>
              {{ $t("fields.additional_timeSheet.request_date") }}
              <span class="require">*</span>
            </label>
            <DatePickerTimeSheet
              :propsDate="dataForm.work_date"
              v-on:emitDate="workDate"
              :rules="{
                required_date: true,
                before_or_equal_today: true,
              }"
              :name="'additional_timeSheet.request_date'"
            />
          </CCol>
          <CCol md="6" class="form-field input-mobile">
            <label>{{ $t("fields.additional_timeSheet.created_date") }}</label>
            <div class="form-control bg-text">
              {{ dataForm.created_at | formatDate }}
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="6" class="form-field">
            <label>
              {{ $t("fields.additional_timeSheet.admin") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="additional_timeSheet.admin"
            >
              <select class="form-control" disabled v-model="dataForm.admin_id">
                <option
                  v-for="(option, index) in dataCreateForm.admin"
                  :key="index"
                  :value="option.id"
                  :selected="dataForm.admin_id == option.id"
                >
                  {{ option.name }}
                </option>
              </select>
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
          <CCol md="6" class="form-field">
            <label>
              Manager
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="additional_timeSheet.manager"
            >
              <select
                class="form-control"
                v-model="dataForm.manager_id"
                disabled
              >
                <option
                  v-for="(option, index) in dataCreateForm.manager"
                  :key="index"
                  :value="option.id"
                  :selected="dataForm.manager_id == option.id"
                >
                  {{ option.name }}
                </option>
              </select>
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
        </CRow>

        <CRow>
          <CCol md="6" class="form-field">
            <label>{{ $t("fields.additional_timeSheet.check_in_real") }}</label>
            <div class="form-control bg-text">
              {{ dataForm.start_time_real | formatHour }}
            </div>
          </CCol>
          <CCol md="6" class="form-field input-mobile">
            <label>
              {{ $t("fields.additional_timeSheet.check_in_request") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="additional_timeSheet.check_in_request"
            >
              <b-form-input
                type="text"
                v-model="dataForm.start_time_request"
                v-mask="'##:##'"
                placeholder="HH:mm"
              />
              <!-- {{ dataForm.start_time_request | formatHour }} -->
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
        </CRow>

        <CRow>
          <CCol md="6" class="form-field">
            <label>{{
              $t("fields.additional_timeSheet.check_out_real")
            }}</label>
            <div class="form-control bg-text">
              {{ dataForm.end_time_real | formatHour }}
            </div>
          </CCol>
          <CCol md="6" class="form-field input-mobile">
            <label>
              {{ $t("fields.additional_timeSheet.check_out_request") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="additional_timeSheet.check_out_request"
            >
              <b-form-input
                type="text"
                v-model="dataForm.end_time_request"
                v-mask="'##:##'"
                placeholder="HH:mm"
              />
              <!-- {{dataForm.end_time_request}} -->
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12" class="form-field">
            <label>{{ $t("fields.additional_timeSheet.evidence") }}</label>
            <span class="require"> *</span><br />
            <a-upload
              :file-list="fileList"
              :multiple="true"
              :beforeUpload="beforeImageUpload"
              @preview="handlePreview"
              @change="handeImageChange"
              list-type="picture"
            >
              <a-button class="btn-ecs-upload">
                <img src="../../assets/icons/file.svg" alt="" />
                Chọn ảnh
              </a-button>
              <br /><span class="require">{{ uploadImageMessage }}</span>
            </a-upload>
            <a-modal
              :zIndex="1030"
              centered
              class="preview-image"
              :visible="previewVisible"
              :footer="null"
              @cancel="handleCancelPreview"
            >
              <img alt="preview" style="width: 100%" :src="previewImage" />
            </a-modal>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("fields.additional_timeSheet.reason") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required|max:512"
              v-slot="{ errors }"
              name="additional_timeSheet.reason"
            >
              <b-form-textarea
                id="textarea"
                v-model="dataForm.reason"
                rows="5"
                max-rows="6"
              ></b-form-textarea>
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12" class="form-data">
            <CButton type="submit" class="save-info">
              {{ $t("label.save_infomation") }}
            </CButton>
            <CButton
              class="cancel-btn"
              type="button"
              @click="showModalConfirmCancel"
              >Hủy bỏ</CButton
            >
          </CCol>
        </CRow>
      </CForm>
    </ValidationObserver>
    <a-modal
      v-model="visible"
      title="Xác nhận hủy chỉnh sửa công"
      :centered="true"
      :footer="null"
      :width="684"
      :zIndex="1030"
    >
      <div class="remove-ot-request">
        <div class="content">
          <img src="../../assets/icons/note.svg" alt="" />
          <p>Bạn có chắc chắn thực hiện hành động này không ?</p>
        </div>

        <CRow class="form-button">
          <CCol md="12" class="employees-form-ot">
            <CButton type="submit" class="save-info" @click="handleCancel()"
              >Xác nhận
            </CButton>
            <CButton
              class="cancel-employee"
              type="button"
              @click="hideModalConfirmCancel()"
              >Ở lại trang
            </CButton>
          </CCol>
        </CRow>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import moment from "moment";
import DatePickerTimeSheet from "@/components/commons/DatePickerTimeSheet";

export default {
  name: "UpdateAdditionalTimesheet",
  props: ["id"],
  metaInfo() {
    return {
      title: this.$t("page_title.page_additional_timeSheet_update"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    DatePickerTimeSheet,
  },
  computed: {
    ...mapGetters({
      dataCreateForm: "additional-timesheet/dataCommonAdditionalTimeSheet",
      dataForm: "additional-timesheet/dataEditAdditionalTimeSheet",
    }),
  },
  data() {
    return {
      errorFileMessage: "",
      visible: false,
      imageType: [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/PNG",
        "image/JPG",
      ],
      fileList: [],
      uploadImageMessage: "",
      isImage: true,
      image_evidence: [],
      image_name: [],
      new_image: [],
      forms: {
        id: "",
        work_date: "",
        admin_id: "",
        manager_id: "",
        start_time_real: "",
        end_time_real: "",
        end_time_request: "17:30",
        start_time_request: "08:00",
        reason: null,
        img_evidence: [],
      },
      previewVisible: false,
      previewImage: "",
    };
  },

  async created() {
    // this.$root.$loading.start();
    await this.$store.dispatch(
      "additional-timesheet/commonAdditionalTimeSheet"
    );
    if (this.$props.id) {
      await this.$store.dispatch(
        "additional-timesheet/editAdditionalTimeSheet",
        this.$props.id
      );
      let imgList = [];
      if (this.dataForm.img_evidence) {
        let imgURL = this.dataForm.img_evidence;
        let fileName = this.getFileNameFromUrl(new URL(imgURL).pathname);
        imgList.push({
          uid: "1",
          name: fileName,
          status: "done",
          url: imgURL,
          thumbUrl: imgURL,
          type: "image/png",
        });
      }
      if (this.dataForm.img_evidence2) {
        let imgURL = this.dataForm.img_evidence2;
        let fileName = this.getFileNameFromUrl(new URL(imgURL).pathname);
        imgList.push({
          uid: "2",
          name: fileName,
          status: "done",
          url: imgURL,
          thumbUrl: imgURL,
          type: "image/png",
        });
      }
      this.fileList = imgList;
    }
    this.$root.$loading.finish();
  },

  methods: {
    //     cancel() {
    //   this.visible = false;
    //   // this.isShowEditModal = false;
    // },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    handleCancelPreview() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    getFileNameFromUrl(url) {
      return url.substring(url.lastIndexOf("/") + 1);
    },
    workDate(data) {
      this.dataForm.work_date = data;
    },
    async registerOverTimeRequest() {
      if (this.fileList.length == 0) {
        this.uploadImageMessage =
          this.$t("additional_timeSheet.evidence") +
          " " +
          this.$t("error.require");
        return false;
      }
      this.$root.$loading.start();
      let formData = new FormData();
      for (let key in this.forms) {
        if (key === "img_evidence") {
          if (this.fileList.length > 0) {
            this.fileList.forEach((file) => {
              if (file.originFileObj) {
                formData.append("img_evidence[]", file.originFileObj);
              }
            });
          }
        } else {
          let data = this.dataForm[key] !== undefined ? this.dataForm[key] : "";
          formData.append(key, data);
        }
      }
      await this.$store
        .dispatch("additional-timesheet/updateAdditionalTimeSheet", formData)
        .then(() => {
          let message = this.$t("additional_timeSheet.message_update_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$emit("ok");
          this.$root.$loading.finish();
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    },

    handeImageChange(info) {
      this.uploadImageMessage = "";
      if (info.fileList.length > 2) {
        this.uploadImageMessage = "Upload tối đa 2 ảnh";
        return;
      }
      this.fileList = [];
      info.fileList.forEach((fileInfo) => {
        if (fileInfo.size > 2000000) {
          this.uploadImageMessage = this.$t("error.img_max");
          return;
        }
        if (this.imageType.includes(fileInfo.type)) {
          this.fileList.push(fileInfo);
        } else {
          this.uploadImageMessage = "Chỉ hỗ trợ định dạng .png, .jpg, .jpeg";
          return;
        }
      });
    },
    beforeImageUpload() {
      return false;
    },

    // change image
    onImageChange(e) {
      if (e.target.files.length + this.new_image.length > 2) {
        this.errorFileMessage = "Vui lòng chọn tối đa 2 ảnh";
        // this.image_evidence =[];
        // this.forms.img_evidence= [];
        this.isImage = false;
        return;
      }

      let file = e.target.files[0];
      let file2 = e.target.files[1];
      if (this.new_image.length === 0) {
        this.image_evidence = [];
        this.forms.img_evidence = [];
        this.image_name = [];
      }

      if (
        e.target.files[0] &&
        !this.imageType.includes(e.target.files[0].type)
      ) {
        this.isImage = false;
        this.dataForm.img_evidence = "";
        this.errorFileMessage = this.$t("error.img_type");
        return;
      }
      if (
        e.target.files[1] &&
        !this.imageType.includes(e.target.files[1].type)
      ) {
        this.isImage = false;
        this.forms.img_evidence = [];
        this.errorFileMessage = this.$t("error.img_type");
        return;
      }
      // check size file
      // if (e.target.files[0] && e.target.files[0].size > 2000000) {
      //   this.isImage = false;
      //   this.errorFileMessage = this.$t("error.img_max");
      //   return;
      // }
      //display image is choosen
      if (file !== undefined) {
        let fileName = file.name;
        this.new_image.push(file);
        this.image_evidence.push(URL.createObjectURL(file));
        this.forms.img_evidence.push(file);
        this.image_name.push(fileName);
      }

      if (file2 !== undefined) {
        let fileName2 = file2.name;
        this.new_image.push(file);
        this.image_evidence.push(URL.createObjectURL(file2));
        this.forms.img_evidence.push(file2);
        this.image_name.push(fileName2);
      }
      // this.image_evidence = file !== undefined ? URL.createObjectURL(file) : "";
      this.errorFileMessage = null;
      this.isImage = true;
      // this.dataForm.img_evidence =
      // e.target.files[0] !== undefined ? e.target.files[0] : "";
    },
    removeImage(index) {
      this.forms.img_evidence.splice(index, 1);
      this.image_evidence.splice(index, 1);
      this.image_name.splice(index, 1);
      this.new_image.splice(index, 1);
      if (
        this.forms.img_evidence.length === 0 &&
        this.image_evidence.length === 0 &&
        this.image_name.length === 0
      ) {
        if (this.dataForm.img_evidence !== null) {
          this.image_evidence.push(this.dataForm.img_evidence);
          this.forms.img_evidence.push(this.dataForm.img_evidence);
        }

        if (this.dataForm.img_evidence2 !== null) {
          this.image_evidence.push(this.dataForm.img_evidence2);
          this.forms.img_evidence.push(this.dataForm.img_evidence2);
        }
      }
    },

    async getDataCreateForm() {
      let date = moment(this.dataForm.work_date, "DD/MM/YYYY", true);
      if (date.isValid()) {
        await this.$store.dispatch(
          "additional-timesheet/commonAdditionalTimeSheet",
          { work_date: this.dataForm.work_date }
        );
        this.dataForm.start_time_real =
          this.dataCreateForm.timeSheet !== null
            ? this.dataCreateForm.timeSheet.start_time_real
            : "";
        this.dataForm.end_time_real =
          this.dataCreateForm.timeSheet !== null
            ? this.dataCreateForm.timeSheet.end_time_real
            : "";
      }
    },

    showModalConfirmCancel() {
      this.visible = true;
    },

    hideModalConfirmCancel() {
      this.visible = false;
    },

    handleCancel() {
      this.$emit("cancel");
    },

    cancel() {
      this.$confirmModal(
        this.$t("popup.commons.label_popup_title"),
        this.$t("popup.commons.label_cancel_update"),
        this.$t("popup.commons.label_confirm_button"),
        this.$t("popup.commons.label_cancel_button"),
        "danger"
      ).then((value) => {
        if (value) {
          this.$emit("cancel");
        }
      });
    },
  },
};
</script>
